const PUBLIC = {
  phoneNumber: "+51917682282",
  email: "pasteleriavalentina2021@hotmail.com",
  license: "",
  orderMethods: [
    "Recojo en tienda",
    "Delivery"
  ]
}

export default PUBLIC;
